export default __webpack_public_path__ + "static/media/story.5ae9156a.jpg";